module.exports = {
	"inports": {
		"module": {
			"process": "Load",
			"port": "path"
		},
		"container": {
			"process": "Mount",
			"port": "container"
		},
		"props": {
			"process": "Props",
			"port": "props"
		}
	},
	"outports": {
		"event": {
			"process": "Listen",
			"port": "event"
		},
		"error": {
			"process": "Errors",
			"port": "out"
		}
	},
	"groups": [],
	"processes": {
		"Load": {
			"component": "amd/Require"
		},
		"Mount": {
			"component": "react/Mount"
		},
		"Listen": {
			"component": "react/ListenEvents"
		},
		"Props": {
			"component": "react/SetProps"
		},
		"Errors": {
			"component": "core/Merge"
		}
	},
	"connections": [
		{
			"src": {
				"process": "Load",
				"port": "module"
			},
			"tgt": {
				"process": "Mount",
				"port": "component"
			}
		},
		{
			"src": {
				"process": "Mount",
				"port": "instance"
			},
			"tgt": {
				"process": "Listen",
				"port": "instance"
			}
		},
		{
			"src": {
				"process": "Mount",
				"port": "instance"
			},
			"tgt": {
				"process": "Props",
				"port": "instance"
			}
		},
		{
			"src": {
				"process": "Load",
				"port": "error"
			},
			"tgt": {
				"process": "Errors",
				"port": "in"
			}
		},
		{
			"src": {
				"process": "Mount",
				"port": "error"
			},
			"tgt": {
				"process": "Errors",
				"port": "in"
			}
		}
	],
	"properties": {
		"environment": {
			"type": "noflo-browser"
		}
	},
	"caseSensitive": false
};